module.exports = __webpack_public_path__ + "img/shopping-bag-3-fill.a53fd3d0.svg";